export const FoxLocationRequest = function (locationCode) {
    this.locationCode = locationCode || null;
};